module.exports = "<div class=\"add-admission-group-panel\">\n  <add-admission-group type=\"{{ admissionGroupType }}\" admission-group=\"admissionGroup\" venue=\"venue\" organization-id=\"{{ organizationId }}\" events=\"events\" event-id=\"{{ eventId }}\" customer=\"customer\" cancel=\"close\" date=\"date\" on-added-or-updated=\"onAddedOrUpdated\"\n      enable-check-in=\"{{ enableCheckIn }}\" enable-confirm=\"{{ enableConfirm }}\" current-tab=\"currentTab\"></add-admission-group>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/panels/addAdmissionGroup/template.html
// module id = 1259
// module chunks = 0